import { Navigate } from 'react-router-dom'
import { authService } from '@/services/auth'
import { ROUTES } from '@/constants/routes'
import { SubscriptionPage } from '@/pages/SubscriptionPage'

export function HomePage() {
  if (authService.isAuthenticated()) {
    return <Navigate to={ROUTES.DASHBOARD} replace />
  }
  return <SubscriptionPage />
}
